exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-form mat-slide-toggle {\n  display: block;\n  margin-top: 20px; }\n\n.row_wrap {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  gap: 2rem; }\n\nmat-form-field {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/gerar-numeracao/numeracao-caixas/numeracao-caixas.component.scss
// module id = ../../../../../src/app/components/caixa/gerar-numeracao/numeracao-caixas/numeracao-caixas.component.scss
// module chunks = main